import { Fragment, memo } from 'react';
import Accountholder from '../shared/accountholder-historical';
import Applicant from '../shared/applicant-historical';
import Payment from '../shared/fragment-payment';

interface HistoricalFormProps {
  disabled?: boolean;
}

const HistoricalFormComponent = ({ disabled }: HistoricalFormProps): React.ReactElement => {
  return (
    <Fragment>
      <Payment />
      <Applicant disabled={disabled} />
      <Accountholder isHistorical />
    </Fragment>
  );
};

HistoricalFormComponent.displayName = 'Historical Form component';

const HistoricalForm = memo(HistoricalFormComponent);

export default HistoricalForm;
